/* JackRabbit â€” "What is JackRabbit?" page + popups.
   Every jr-* section loads this file; the guard makes repeat loads harmless,
   and custom elements re-initialise when the theme editor re-renders a section. */
(function () {
  if (window.__jrLanding) return;
  window.__jrLanding = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Haptics (phones) ----------
     Android: the Vibration API. iPhone (iOS 18+): Safari has no Vibration
     API, but tapping a native switch control plays the system "tick", so a
     hidden <input switch> is clicked instead. Browsers only allow this during
     a tap, so it only ever answers something the visitor did, never the
     automatic hint animations. Off when the JR: Popups "Haptic feedback"
     setting is unchecked, and never on mouse/trackpad devices. */
  var touchDevice = window.matchMedia('(pointer: coarse)').matches;
  var canVibrate = typeof navigator.vibrate === 'function';
  var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var HAPTIC = { selection: 6, light: 10, medium: 18, success: [10, 60, 14], blocked: [16, 50, 16] };
  var lastHaptic = 0, iosSwitch = null;
  function hapticsOn() {
    if (!touchDevice) return false;
    var host = document.querySelector('[data-jr-popups]');
    return !host || host.hasAttribute('data-jr-haptics');
  }
  function iosTick() {
    if (!iosSwitch) {
      iosSwitch = document.createElement('label');
      iosSwitch.setAttribute('aria-hidden', 'true');
      iosSwitch.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('switch', '');
      input.tabIndex = -1;
      iosSwitch.appendChild(input);
    }
    document.head.appendChild(iosSwitch);
    iosSwitch.click();
    document.head.removeChild(iosSwitch);
  }
  function haptic(type) {
    var now = Date.now();
    if (now - lastHaptic < 60 || !hapticsOn()) return; // one pulse per gesture
    lastHaptic = now;
    var pattern = HAPTIC[type] || HAPTIC.light;
    try {
      if (canVibrate) { navigator.vibrate(pattern); return; }
      if (isIOS) {
        iosTick();
        if (Array.isArray(pattern)) setTimeout(iosTick, pattern[0] + pattern[1]);
      }
    } catch (e) { /* haptics are a nicety; never break the page */ }
  }

  /* ---------- Reveal on scroll ---------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 })
    : null;

  function wireReveals(root) {
    root.querySelectorAll('[data-jr-reveal]:not([data-jr-wired])').forEach(function (el) {
      el.setAttribute('data-jr-wired', '');
      if (!revealObserver || reduceMotion || el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-visible');
        return;
      }
      revealObserver.observe(el);
    });
  }

  /* ---------- Count-up numbers (e.g. "15 mph") ---------- */
  function countUp(el) {
    if (reduceMotion || el.dataset.jrCounted) return;
    el.dataset.jrCounted = '1';
    var original = el.textContent;
    var parts = original.split(/(\d+(?:\.\d+)?)/);
    if (parts.length < 2) return;
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / 1000, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = parts.map(function (part, i) {
        if (i % 2 === 0) return part;
        var decimals = (part.split('.')[1] || '').length;
        return (parseFloat(part) * eased).toFixed(decimals);
      }).join('');
      if (p < 1) requestAnimationFrame(frame); else el.textContent = original;
    }
    requestAnimationFrame(frame);
  }

  class JrSection extends HTMLElement {
    connectedCallback() {
      this.classList.add('jr-js');
      wireReveals(this);
      var counters = this.querySelectorAll('[data-jr-count]');
      if (!counters.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { io.observe(c); });
    }
  }
  if (!customElements.get('jr-section')) customElements.define('jr-section', JrSection);

  /* Horizontal card rows on phones: position dots, an edge fade on the side
     with more cards, and a one-time nudge when the row first scrolls into view. */
  function setupScroller(row) {
    if (row._jrScroller) return;
    row._jrScroller = true;
    var items = Array.prototype.slice.call(row.children);
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'jr-dots';
    dots.setAttribute('aria-hidden', 'true');
    items.forEach(function (item, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.tabIndex = -1;
      d.addEventListener('click', function () {
        haptic('selection');
        row.scrollTo({ left: item.offsetLeft - row.offsetLeft - parseFloat(getComputedStyle(row).paddingLeft || 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      dots.appendChild(d);
    });
    row.parentNode.insertBefore(dots, row.nextSibling);
    var touched = false, activeCard = -1;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      row.addEventListener(ev, function () { touched = true; }, { passive: true });
    });
    function update() {
      var scrollable = row.scrollWidth - row.clientWidth > 4;
      dots.hidden = !scrollable;
      row.classList.toggle('is-start', row.scrollLeft < 4);
      row.classList.toggle('is-end', row.scrollWidth - row.clientWidth - row.scrollLeft < 4);
      if (!scrollable) return;
      var mid = row.scrollLeft + row.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (item, i) {
        var c = item.offsetLeft - row.offsetLeft + item.offsetWidth / 2;
        var dd = Math.abs(c - mid);
        if (dd < bestD) { bestD = dd; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === best); });
      // A light tick each time the visitor's swipe lands on a new card
      if (touched && activeCard !== -1 && best !== activeCard) haptic('selection');
      activeCard = best;
    }
    row.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    function nudge(done) {
      if (touched || row.scrollWidth - row.clientWidth < 4) return;
      var start = row.scrollLeft;
      var dist = Math.min(140, Math.max(72, (items[0].offsetWidth || 240) * 0.38));
      row.style.scrollSnapType = 'none';
      row.scrollTo({ left: start + dist, behavior: 'smooth' });
      setTimeout(function () {
        if (!touched) row.scrollTo({ left: start, behavior: 'smooth' });
        setTimeout(function () { row.style.scrollSnapType = ''; if (done) done(); }, 520);
      }, 700);
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () {
        nudge(function () { setTimeout(function () { nudge(); }, 3000); });
      }, 400);
    }, { threshold: 0.6 });
    io.observe(row);
  }
  function wireScrollers(root) { (root || document).querySelectorAll('[data-jr-scroller]').forEach(setupScroller); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wireScrollers(); }); else wireScrollers();
  document.addEventListener('shopify:section:load', function (e) { wireScrollers(e.target); });

  /* ---------- Timeline: all cards share the tallest card's height ---------- */
  function equalizeTimelines() {
    document.querySelectorAll('.jr-timeline').forEach(function (tl) {
      var cards = tl.querySelectorAll('.jr-tcard');
      if (!cards.length) return;
      tl.style.setProperty('--jr-tcard-h', '0px');
      var max = 0;
      cards.forEach(function (c) { max = Math.max(max, c.offsetHeight); });
      tl.style.setProperty('--jr-tcard-h', Math.ceil(max) + 'px');
    });
  }
  var eqTimer;
  function queueEqualize() { clearTimeout(eqTimer); eqTimer = setTimeout(equalizeTimelines, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', equalizeTimelines); else equalizeTimelines();
  window.addEventListener('load', equalizeTimelines);
  window.addEventListener('resize', queueEqualize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalizeTimelines);
  document.addEventListener('shopify:section:load', queueEqualize);
  document.addEventListener('shopify:block:select', queueEqualize);

  /* =======================================================================
     Popups
     ======================================================================= */
  var lastTrigger = null;

  function getModal(id) { return document.getElementById('jr-modal-' + id); }

  function openModal(id, trigger) {
    var dialog = getModal(id);
    if (!dialog || dialog.open) return;
    lastTrigger = trigger || document.activeElement;
    if (trigger) haptic('medium');
    setupModal(dialog);
    document.documentElement.classList.add('jr-modal-open');
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    var body = dialog.querySelector('.jr-modal__body');
    if (body) body.scrollTop = 0;
    dialog.querySelectorAll('[data-jr-swipe]').forEach(function (s) { s._jrReset && s._jrReset(); });
    if (dialog._jrAccReset) dialog._jrAccReset();
    refreshFades(dialog);
    dialog.dispatchEvent(new Event('jr:opened'));
    setTimeout(function () { updateScrollCue(dialog); peekScroll(dialog); }, 420);
    var close = dialog.querySelector('[data-jr-modal-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeModal(dialog, instant) {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    if (!instant) haptic('light');
    var finish = function () {
      dialog.classList.remove('is-closing', 'is-dragging');
      var panel = dialog.querySelector('.jr-modal__panel');
      if (panel) panel.style.transform = '';
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
      if (!document.querySelector('dialog.jr-modal[open]')) document.documentElement.classList.remove('jr-modal-open');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    };
    if (instant || reduceMotion) return finish();
    dialog.classList.add('is-closing');
    setTimeout(finish, 210);
  }

  function setupModal(dialog) {
    if (dialog._jrReady) return;
    dialog._jrReady = true;

    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(dialog); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-jr-modal-close]')) closeModal(dialog);
    });

    dialog.querySelectorAll('[data-jr-swipe]').forEach(setupSwipe);
    setupAccordions(dialog);
    dialog.querySelectorAll('[data-jr-more]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-jr-more-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        haptic(open ? 'light' : 'selection');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      dialog.addEventListener('jr:opened', function () {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
    dialog.querySelectorAll('[data-jr-fade]').forEach(function (el) {
      el.addEventListener('scroll', function () { updateFade(el); }, { passive: true });
    });
    setupDrag(dialog);
    setupScrollCue(dialog);
  }

  /* "More below" cue: a bottom fade plus a small bouncing pill whenever the
     popup body has more content than fits. Tap the pill to scroll on. */
  function setupScrollCue(dialog) {
    var body = dialog.querySelector('.jr-modal__body');
    var panel = dialog.querySelector('.jr-modal__panel');
    if (!body || !panel) return;
    var cue = document.createElement('button');
    cue.type = 'button';
    cue.className = 'jr-morecue';
    cue.setAttribute('aria-label', 'Scroll for more');
    cue.innerHTML = '<span>More</span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    panel.appendChild(cue);
    cue.addEventListener('click', function () {
      haptic('selection');
      body.scrollBy({ top: Math.max(120, body.clientHeight * 0.7), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    body.addEventListener('scroll', function () { updateScrollCue(dialog); }, { passive: true });
    dialog._jrCue = cue;
    if (window.ResizeObserver) new ResizeObserver(function () { updateScrollCue(dialog); }).observe(body);
  }
  function updateScrollCue(dialog) {
    var body = dialog.querySelector('.jr-modal__body');
    var cue = dialog._jrCue;
    if (!body || !cue) return;
    var more = body.scrollHeight - body.clientHeight - body.scrollTop > 12;
    body.classList.toggle('has-more', more);
    var foot = dialog.querySelector('.jr-modal__foot');
    cue.style.bottom = ((foot ? foot.offsetHeight : 0) + 10) + 'px';
    cue.classList.toggle('is-shown', more);
  }
  /* One gentle peek the first time a scrollable popup opens */
  function peekScroll(dialog) {
    var body = dialog.querySelector('.jr-modal__body');
    if (reduceMotion || !body || dialog._jrPeeked) return;
    if (body.scrollHeight - body.clientHeight < 40 || body.scrollTop > 0) return;
    dialog._jrPeeked = true;
    body.scrollTo({ top: 56, behavior: 'smooth' });
    setTimeout(function () { if (body.scrollTop <= 60) body.scrollTo({ top: 0, behavior: 'smooth' }); }, 650);
  }

  function updateFade(el) {
    var more = el.scrollHeight - el.clientHeight - el.scrollTop > 4;
    el.classList.toggle('is-more', more);
  }
  function refreshFades(root) {
    requestAnimationFrame(function () { root.querySelectorAll('[data-jr-fade]').forEach(updateFade); });
  }

  /* Swipe row with labelled tabs (narrow screens). On wide screens the
     same markup is a plain grid and the tabs are hidden. */
  function setupSwipe(wrap) {
    var track = wrap.querySelector('[data-jr-swipe-track]');
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-jr-swipe-tab]'));
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-jr-swipe-item]'));
    if (!track || !items.length) return;
    var current = 0;
    var pick = wrap.classList.contains('jr-swipe--pick');
    var wide = window.matchMedia('(min-width: 900px)');
    function startIndex() { return pick && wide.matches ? 1 : 0; }

    items.forEach(function (item, i) {
      var id = (wrap.closest('dialog').id || 'jr') + '-card-' + i;
      item.id = id;
      if (tabs[i]) { tabs[i].setAttribute('aria-controls', id); }
    });

    function setActive(i) {
      current = i;
      items.forEach(function (item, n) { item.classList.toggle('is-current', n === i); });
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var p = t.parentNode;
          p.scrollTo({ left: t.offsetLeft - (p.clientWidth - t.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    }
    function goTo(i, smooth) {
      var item = items[i];
      if (!item) return;
      track.scrollTo({ left: item.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActive(i);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { if (i !== current) haptic('selection'); goTo(i, true); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = Math.min(i + 1, tabs.length - 1);
        if (e.key === 'ArrowLeft') n = Math.max(i - 1, 0);
        if (n === null) return;
        e.preventDefault(); goTo(n, true); tabs[n].focus();
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking || (pick && wide.matches)) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var left = track.scrollLeft, best = 0, bestD = Infinity;
        items.forEach(function (item, i) {
          var d = Math.abs(item.offsetLeft - track.offsetLeft - 16 - left);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (best !== current) setActive(best);
      });
    }, { passive: true });
    wrap._jrReset = function () { goTo(startIndex(), false); };
    var onWide = function () { if (pick && wide.matches && current === 0) setActive(1); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    setActive(startIndex());
  }

  /* Tap-to-open rows. Phones only: on wider screens every row is open and
     the header is a plain heading (not focusable). One row open at a time. */
  var phone = window.matchMedia('(max-width: 749px)');
  function setupAccordions(dialog) {
    var cards = Array.prototype.slice.call(dialog.querySelectorAll('[data-jr-acc]'));
    if (!cards.length) return;
    cards.forEach(function (card) { card._jrDefault = card.classList.contains('is-open'); });
    function sync() {
      cards.forEach(function (card) {
        var head = card.querySelector('.jr-acc__head');
        var open = card.classList.contains('is-open');
        head.tabIndex = phone.matches ? 0 : -1;
        head.setAttribute('aria-expanded', !phone.matches || open ? 'true' : 'false');
      });
    }
    cards.forEach(function (card) {
      var head = card.querySelector('.jr-acc__head');
      head.addEventListener('click', function () {
        if (!phone.matches) return;
        var willOpen = !card.classList.contains('is-open');
        // Groups marked data-jr-acc-keep-one (state laws) always keep one row open
        if (!willOpen && card.parentNode.hasAttribute('data-jr-acc-keep-one')) { haptic('blocked'); return; }
        haptic(willOpen ? 'light' : 'selection');
        cards.forEach(function (c) { if (c.parentNode === card.parentNode) c.classList.remove('is-open'); });
        if (willOpen) card.classList.add('is-open');
        sync();
        dialog.classList.add('jr-acc-touched');
        setTimeout(function () { updateScrollCue(dialog); }, 60);
        if (willOpen && card.scrollIntoView) {
          setTimeout(function () { card.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }); }, 30);
        }
      });
    });
    dialog._jrAccReset = function () {
      dialog.classList.remove('jr-acc-touched');
      cards.forEach(function (card) { card.classList.toggle('is-open', card._jrDefault); });
      sync();
    };
    if (phone.addEventListener) phone.addEventListener('change', sync);
    sync();
  }

  /* Drag the sheet down by its handle to close (phones). */
  function setupDrag(dialog) {
    var grab = dialog.querySelector('[data-jr-modal-grab]');
    var panel = dialog.querySelector('.jr-modal__panel');
    if (!grab || !panel || !window.PointerEvent) return;
    var startY = 0, dy = 0, dragging = false, armed = false;
    grab.addEventListener('pointerdown', function (e) {
      dragging = true; startY = e.clientY; dy = 0; armed = false;
      grab.setPointerCapture(e.pointerId);
      dialog.classList.add('is-dragging');
    });
    grab.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
      // Tick when the sheet has been pulled far enough to close on release
      if ((dy > 90) !== armed) { armed = dy > 90; if (armed) haptic('selection'); }
    });
    var end = function () {
      if (!dragging) return;
      dragging = false;
      if (dy > 90) { lastHaptic = 0; closeModal(dialog); return; }
      dialog.classList.remove('is-dragging');
      panel.style.transition = 'transform .2s ease';
      panel.style.transform = '';
      setTimeout(function () { panel.style.transition = ''; }, 220);
    };
    grab.addEventListener('pointerup', end);
    grab.addEventListener('pointercancel', end);
  }

  /* Triggers: buttons with data-jr-modal-open="<id>", or links to #jr-modal-<id> */
  document.addEventListener('click', function (e) {
    // Every other tappable thing on the page (buttons, cards, links) gets a light tap
    var tap = e.target.closest && e.target.closest('.jr a[href], .jr button, .jr [role="tab"]');
    if (tap && !tap.matches('[data-jr-modal-open], a[href^="#jr-modal-"]')) haptic('light');
    var t = e.target.closest && e.target.closest('[data-jr-modal-open], a[href^="#jr-modal-"]');
    if (t) {
      var id = t.getAttribute('data-jr-modal-open') || t.getAttribute('href').replace('#jr-modal-', '');
      if (getModal(id)) { e.preventDefault(); openModal(id, t); }
      return;
    }
    var link = e.target.closest && e.target.closest('.jr a[href^="#"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  window.addEventListener('resize', function () {
    var open = document.querySelector('dialog.jr-modal[open]');
    if (open) refreshFades(open);
  });

  function openFromHash() {
    var m = /^#jr-modal-([\w-]+)$/.exec(location.hash);
    if (m) openModal(m[1]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash); else openFromHash();
  window.addEventListener('hashchange', openFromHash);

  window.JackRabbitPopups = { open: openModal, close: function (id) { closeModal(getModal(id)); } };

  /* Theme editor: selecting a popup block opens it; deselecting closes it. */
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('dialog.jr-modal');
    if (d) openModal(d.id.replace('jr-modal-', ''));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var d = e.target.closest && e.target.closest('dialog.jr-modal');
    if (d) closeModal(d, true);
  });
})();